import script from "./tutorOnboardingSixthPage.vue?vue&type=script&setup=true&lang=js"
export * from "./tutorOnboardingSixthPage.vue?vue&type=script&setup=true&lang=js"

import "./tutorOnboardingSixthPage.vue?vue&type=style&index=0&id=2c48eca7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c48eca7"]])

export default __exports__